// extracted by mini-css-extract-plugin
export default {"svg":"PaymentSettings_svg__tyTAR","form":"PaymentSettings_form__2dp6o","btnWrapper":"PaymentSettings_btnWrapper__PJSth"};